import React from 'react'
import './index.scss'
import { Controller, FieldError, useFormContext } from 'react-hook-form'
import PhoneInput from 'react-phone-number-input/max'
import flags from 'react-phone-number-input/flags'
import 'react-phone-number-input/style.css'
import FormFieldProps, { FormFieldType } from '@App/forms/v2/common/form-field'
import getInputName from '@App/forms/v2/helpers/get-input-name'
import FieldErrorSectionForm from '@Fields/v2/FieldErrorSectionForm'
import {
    InternationalPhoneNumberType,
    phoneCountryCodeKey,
    fullPhoneNumberKey,
    joinPhoneNumber,
    splitPhoneNumber,
} from '@Entities/schemas/common/international-phone-number-schema'

export interface InternationalPhoneInputProps extends FormFieldProps {
    phoneNumberFormFields?: FormFieldType<InternationalPhoneNumberType>
}

const InternationalPhoneInput = (props: InternationalPhoneInputProps) => {
    const { control, setValue } = useFormContext()

    const inputName = getInputName(props)

    const { label } = props

    return (
        <div className="international-phone-input-component">
            <label className="small">{label}</label>
            <Controller
                name={inputName}
                control={control}
                defaultValue={{ [phoneCountryCodeKey]: '', [fullPhoneNumberKey]: '' }}
                render={({ field: { value, onBlur, name }, fieldState }) => {
                    const phoneValue = (value ?? {}) as Partial<InternationalPhoneNumberType>

                    // zod attaches errors to the nested keys; surface them to the shared error section.
                    const nestedError = fieldState.error as
                        (FieldError & Partial<Record<keyof InternationalPhoneNumberType, FieldError>>) | undefined
                    const fieldError =
                        nestedError?.[fullPhoneNumberKey] ?? nestedError?.[phoneCountryCodeKey] ?? nestedError

                    return (
                        <>
                            <PhoneInput
                                name={name}
                                flags={flags}
                                defaultCountry="US"
                                international
                                limitMaxLength
                                className={fieldError ? 'error' : undefined}
                                value={joinPhoneNumber(phoneValue)}
                                onChange={(newValue) => {
                                    setValue(name, splitPhoneNumber(newValue), {
                                        shouldDirty: true,
                                        shouldTouch: true,
                                        shouldValidate: true,
                                    })
                                }}
                                onBlur={onBlur}
                            />
                            <FieldErrorSectionForm {...props} fieldError={fieldError} />
                        </>
                    )
                }}
            />
        </div>
    )
}

export default InternationalPhoneInput
